export const START_LOADING = 'START_LOADING';
export const STOP_LOADING = 'STOP_LOADING';

export const SET_ERROR = 'SET_ERROR';
export const RESET_ERROR = 'RESET_ERROR';

export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const SIGNOUT = 'SIGNOUT';

export const SET_DONE = 'SET_DONE'; 

export const ADD_LINK = 'ADD_LINK';
export const SET_LINKS = 'SET_LINKS';
export const SET_CURR = 'SET_CURR';
export const SET_HIDE = 'SET_HIDE';